import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import CompleteTick from "wonderbly-components/lib/CompleteTick";

import "./CanvasDrawerLabel.scss";

const CanvasDrawerLabel = (props) => (
  <div
    data-hook={`canvas-drawer-${props.drawerId}-label`}
    className={cx("canvas-drawer-label", {
      "canvas-drawer-label--open": props.isOpen,
      "canvas-drawer-label--hidden": props.drawer.isHidden,
    })}
    onClick={props.onClick}
  >
    <div className="canvas-drawer-label-subtitle-wrap">
      <div className="canvas-drawer-label-subtitle">{props.subtitle}</div>
    </div>
    <div className="canvas-drawer-label-title-wrap">
      <CompleteTick ticked={props.isDrawerComplete} />
      <div
        className={cx("canvas-drawer-label-title", {
          "canvas-drawer-label-title--completed": props.isDrawerComplete,
        })}
      >
        {props.isDrawerComplete ? props.completedTitle : props.title}
      </div>
    </div>
  </div>
);

CanvasDrawerLabel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isDrawerComplete: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  completedTitle: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  drawer: PropTypes.shape({
    isHidden: PropTypes.bool,
  }).isRequired,
  drawerId: PropTypes.string,
  productId: PropTypes.string.isRequired,
};

export default CanvasDrawerLabel;
